import { enqueueSnackbar } from 'notistack';
import { createAction } from 'redux-actions';

import { resetForm } from '@gef-ui/form-core/stream/transfer/control';
import { getMessage } from '@gef-ui/localization/messages';

import fetch from 'features/common/fetch';
import user from 'features/views/user';

import {
	ADD_NOTE,
	APPEND_ADDITONAL_DATA_TO_CONTACT,
	RESET_DETAIL,
	SAVE_DATA,
	SET_CAME_TO_DETAIL_FROM,
} from './actionTypes';
import { CONTACT_DETAIL_FORM, FIELDS } from './form';

const saveData = createAction(SAVE_DATA, (contactDetailData) => ({ contactDetailData }));
const addNote = createAction(ADD_NOTE, (comment, firstname, surname) => ({ comment, firstname, surname }));
const resetDetail = createAction(RESET_DETAIL);
export const setCameToDetailFrom = createAction(SET_CAME_TO_DETAIL_FROM, (cameToDetailFrom) => ({ cameToDetailFrom }));

const appendAdditionalDataToContact = createAction(APPEND_ADDITONAL_DATA_TO_CONTACT, (additionalData) => ({
	additionalData,
}));

export const getContactDetail = (contactId) => (dispatch, getState) => {
	return dispatch(
		fetch.actions.get(fetch.constants.urls.contactDetail, {
			uniqueReqID: 'get',
			replaceParams: {
				id: contactId,
			},
			queryParams: {
				userRole: user.selectors.getCurrentRole(getState()),
			},
			onSuccess: [(response) => () => dispatch(saveData(response.body))],
			//onError logic - in ContactDetail useEffect because of "navigate"
			shouldReportError: ({ failure }) => {
				return failure?.status !== 404;
			},
		}),
	);
};

export const resetContactDetail = () => (dispatch) => {
	dispatch(resetDetail());
};

export const fetchContactAdditionalData = (contactId) => (dispatch, getState) => {
	return dispatch(
		fetch.actions.get(fetch.constants.urls.contactAdditionalData, {
			uniqueReqID: 'get',
			replaceParams: {
				id: contactId,
			},
			queryParams: {
				userRole: user.selectors.getCurrentRole(getState()),
			},
			onSuccess: [
				(response) => () => {
					const { additionalData } = response.body;
					return dispatch(appendAdditionalDataToContact(additionalData));
				},
			],
		}),
	);
};

export const addComment =
	(contactId) =>
	async (dispatch, getState, { sendControlNext, getFormFieldValue }) => {
		const state = getState();
		const comment = await getFormFieldValue({
			formName: CONTACT_DETAIL_FORM,
			fieldName: FIELDS.note,
		});
		const firstName = user.selectors.getFirstName(state);
		const surname = user.selectors.getSurname(state);

		const fetchAction = fetch.actions.post(fetch.constants.urls.contactDetailComment, {
			replaceParams: { id: contactId },
			body: { comment },
		});

		return dispatch(fetchAction)
			.then(() => {
				dispatch(addNote(comment, firstName, surname));
				enqueueSnackbar(getMessage('toastr:approveTextHeader'), { variant: 'success' });
				sendControlNext(CONTACT_DETAIL_FORM, resetForm());
				dispatch(getContactDetail(contactId));
			})
			.catch(() => enqueueSnackbar(getMessage('toastr:errorTextHeader'), { variant: 'error' }));
	};
